import { render, staticRenderFns } from "./RequestDataDetailsPage.vue?vue&type=template&id=d0a50662&scoped=true&"
import script from "./RequestDataDetailsPage.vue?vue&type=script&lang=js&"
export * from "./RequestDataDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestDataDetailsPage.vue?vue&type=style&index=0&id=d0a50662&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0a50662",
  null
  
)

export default component.exports